export default {
  upTo: 'hasta {value}',
  kpi: 'KPI',
  restrictions: 'Restricciones',
  timeRestrictions: 'Restricciones de tiempo',
  allChannels: 'Todos los Canales',
  fullPeriod: 'Período Completo',
  spendIn: 'Gasto en',
  and: 'y',
  unrestricted: 'Sin restricción',
  moreThan: 'Más de',
  lessThan: 'Menos de',
  between: 'Entre',
  exactly: 'Exactamente',
  mediaSpendCalendar: 'Calendario de Inversión en Medios ({unit})',
  kpiWeighting: 'Ponderación de KPI',
  kpiAutoBalance: 'Auto-Balance'
}
